import { http } from '@/lib/http'

import {
  TrackActionChainRequestSchema,
  type TrackActionChainRequest,
} from '../schemas/action-chain'

/**
 * 上报一条行为链路节点。同一个 chainId 的多次调用为更新（同节点按最新值覆盖）。
 * 响应 data 为 null，业务成功与否由 http 拦截器按 code 判定，此处不再解析响应体。
 */
export const trackActionChain = async (
  payload: TrackActionChainRequest,
): Promise<void> => {
  TrackActionChainRequestSchema.parse(payload)
  await http
    .post('external/image-proofing/action-chains/track', { json: payload })
    .json()
}
